import React from 'react'
import './PageTitle.css'

const PageTitle = ({ title, rightNav }) => {
  const simpleTitle = (
    <div className='pageTitle'>
      <h3>{title}</h3>
    </div>
  )

  if(!rightNav) {return simpleTitle}

  return(
    <div className="row pageTitle">
      <div className="col-md-6">
        <h3>{title}</h3>
      </div>
      <div className="col-md-6">
        {rightNav}
      </div>
    </div>
  )
}

export default PageTitle


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/PageTitle/PageTitle.jsx